import React, { Component } from "react";

export class Loading extends Component {

	render() {
		return <div className={`loading-full-screen${this.props.show ? "" : " -hidden"}`} />;
	}
}


// WEBPACK FOOTER //
// src/atoms/lib/Loading.js